// extracted by mini-css-extract-plugin
module.exports = {"trailer":"hA","imgWrapper":"hB","thumbnail":"hC","isRental":"hD","playWrapper":"hE","playImg":"hF","title":"hG","iconWrapper":"hH","navArrow":"hI"};